module.exports = __webpack_public_path__ + "static/assets/713ba3927bb12c7ffde945efb44ed027.svg";